export class BtmCarrier {
    private readonly _name: string;
    private readonly _isBulky: boolean;

    constructor(name: string, isBulky: boolean | undefined) {
        this._name = name;
        this._isBulky = isBulky ?? false;
    }

    get name() {
        return this._name;
    }

    get isBulky() {
        return this._isBulky;
    }
}
